module.exports = __webpack_public_path__ + "img/hr-ccm-belt-04a-sequence.2d973d20.png";